import * as React from "react";
import {
    Box, Card, Chip, Container, IconButton, InputAdornment, MenuItem, TextField, Typography, Alert, Stack, Divider,
} from "@mui/material";
import ButtonComponent from "components/Button";
import { getPrice, isMarketPlace, checkProductInCart, isAuthorized, getURI } from "helpers/utils";


import { useState, useEffect } from "react";

import { H2, H5 } from "components/CustomTypography";
import ImageAlbum from "components/elements/main/ImageAlbum";
import ShopHeaderOurCollection from "components/elements/user/shops/ShopHeaderOurCollection";
import ShopProductPopularSlider from "components/elements/user/products/ShopProductPopularSlider";
import ShopProductNewSlider from "components/elements/user/products/ShopProductNewSlider";
import ShopOffersSlider from "components/elements/user/offers/ShopOffersSlider";
import MockGeneralHeader from "components/elements/main/MockGeneralHeader";
import MockProductImage from "components/elements/main/MockProductImage";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import CircularProgress from "@mui/material/CircularProgress";
import { FlexBox } from "components/flex-box";
import SelectFieldComponent from "components/SelectField";
import ShopHeaderBack from "../../../main/ShopHeaderBack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "actions/user/user-base.actions";


const ShopProductDetail = (props) => {

    const {
        selectedProduct, currency, onAddToWishlistClicked, onAddToCartClicked, messageShopClicked, onCancel, productdetail,
        isLoading, history, shopId, bootupInfo, cartItems, isCartLoading, cartAddingPid,
        reqStatus, serviceError, tryonCredits, tryonProfileImage, virtualTryOnResult,
        generateVirtualTryOn, getTryOnProfileImage, getTryOnCredits
    } = props;

    const [state, setState] = useState({});
    const [share, setShare] = useState(false);
    const [sizeState, setSizeState] = useState("");
    const [isGenerating, setIsGenerating] = useState(false);

    const product = productdetail;

    const {
        created_at: createdAt, _id: _id, status, message
    } = selectedProduct || {};

    useEffect(() => {
        if (isAuthorized()) {
            getTryOnCredits();
        }
    }, []);

    useEffect(() => {
        if (reqStatus === "GENERATE_VIRTUAL_TRYON_SUCCESS") {
            setIsGenerating(false);
            history.push(getURI(process.env.REACT_APP_TYPE, "tryon", ""));
        } else if (reqStatus === "GENERATE_VIRTUAL_TRYON_FAILURE") {
            setIsGenerating(false);
            history.push(getURI(process.env.REACT_APP_TYPE, "tryon", ""));
        }
    }, [reqStatus]);

    const handleTryOn = () => {
        if (!product || !product.product_id) {
            alert("Product information not available");
            return;
        }

        if (!tryonProfileImage) {
            alert("Please upload a profile image first in your account settings");
            return;
        }

        if (tryonCredits?.credits <= 0) {
            alert("You don't have enough credits for virtual try-on");
            return;
        }

        setIsGenerating(true);
        generateVirtualTryOn(product.product_id, tryonProfileImage._id, 1);
    };

    const handleShare = () => {
        setShare(!share);
    };

    const inputSizeOptions = product.size && product.size.map((item) => {
        return (
            <MenuItem value={item}>{item}</MenuItem>
        );
    });

    const handleSizeClick = (event) => {
        setSizeState(event.target.value);
    };

    const handleVisitPage = () => {
        history.push(getURI(process.env.REACT_APP_TYPE, "tryon_profile", ""))
    };

    const renderProductSize = () => (
        <SelectFieldComponent
            size="small"
            required
            options={inputSizeOptions}
            label="Size"
            value={sizeState}
            onChange={(event) => handleSizeClick(event)}
        />
    );


    const renderProductInformation = () => (
        <Box width="100%" >
            <Box mb={2} width="100%" display="flex" alignItems="center">
                <Box width="40%" >
                    <H2 fontSize={18} textAlign="left">
                        {getPrice(product, currency)}
                    </H2>
                </Box>
                <Box width="60%" display="flex" justifyContent="flex-end">
                    {
                        product.is_price_visible && parseFloat(product.price).toFixed(0) > 0 &&
                        (checkProductInCart(cartItems, product.product_id) ?
                            <ShoppingCartIcon color="primary" />
                            :
                            (isCartLoading && cartAddingPid === product.product_id ?
                                <CircularProgress size="1rem" />
                                :
                                <>
                                    <Box width="40%" display="flex" justifyContent="flex-end">
                                        {(product.size && product.size.length > 0) &&
                                            renderProductSize()
                                        }
                                    </Box>
                                    <Box width="60%" display="flex" justifyContent="flex-end">
                                        <ButtonComponent
                                            sx={{
                                                mt: 2,
                                                mb: 2,
                                            }}
                                            type="primary"
                                            variant="contained"
                                            name="Add to cart"
                                            size="small"
                                            onClick={() => onAddToCartClicked(product.product_id, shopId, !isMarketPlace(), sizeState)}
                                        />
                                    </Box>
                                </>
                            )
                        )
                    }
                </Box>
            </Box>
            <Box width="100%" >
                <FlexBox width="100%" alignItems="left">
                    <Box width="50%">
                        <H5 fontSize={14} textAlign="left" >
                            {parseInt(product.fav) > 0 ?
                                <ButtonComponent
                                    sx={{
                                        mt: 2,
                                        mb: 2,
                                    }}
                                    disabled
                                    variant="contained"
                                    name="Liked!"
                                    size="small"
                                />
                                :
                                isCartLoading ? <CircularProgress size="1rem" /> :
                                    <>
                                        <ButtonComponent
                                            sx={{
                                                mt: 2,
                                                mb: 2,
                                            }}
                                            type="primary"
                                            variant="contained"
                                            name="Like!"
                                            size="small"
                                            onClick={() => onAddToWishlistClicked(product.product_id)}
                                        />
                                    </>
                            }
                        </H5>

                    </Box>
                </FlexBox>
            </Box>
        </Box>
    );
    const renderProductPhotos = () => (
        <Box>
            <ImageAlbum images={product.images} mainOnly={true} />
        </Box>
    );


    const renderProductShopMoreInfo = () => (
        <Box>
            <ShopProductPopularSlider includeHeader={true} shopId={isMarketPlace() ? shopId : bootupInfo.appState.subdomain_shopId} />
            <ShopProductNewSlider includeHeader={true} shopId={shopId} />
        </Box>
    );

    const renderVirtualTryOn = () => {
        if (!isAuthorized()) return null;

        return (
            <Box sx={{ mt: 3 }}>
                <Divider sx={{ mb: 2 }} />
                <Stack spacing={2}>
                    {tryonCredits && (
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <H5 fontSize={14}>Virtual Try-On Credits:</H5>
                            <H5 fontSize={14} color="primary">{tryonCredits.balance || 0}</H5>
                        </Box>
                    )}

                    <ButtonComponent
                        type="primary"
                        variant="contained"
                        name={isGenerating ? "Generating..." : "Try On! (Using AI)"}
                        size="medium"
                        fullWidth
                        onClick={handleTryOn}
                        disabled={isGenerating || !tryonProfileImage || (tryonCredits?.balance <= 0)}
                        startIcon={isGenerating && <CircularProgress size={20} />}
                    />

                    {!tryonProfileImage && (
                        <Alert severity="info">
                            Upload a profile image to use virtual try-on
                            <ButtonComponent
                                type="primary"
                                variant="contained"
                                size="small"
                                name="Upload Profile Image"
                                onClick={handleVisitPage} />
                        </Alert>
                    )}

                    {virtualTryOnResult && virtualTryOnResult.generated_images && virtualTryOnResult.generated_images.length > 0 && (
                        <Box>
                            <H5 fontSize={14} sx={{ mb: 2 }}>Try-On Result:</H5>
                            {virtualTryOnResult.generated_images.map((img, index) => (
                                <Box key={index} sx={{ mb: 2 }}>
                                    <img
                                        src={img.cdn?.secure_url || img.url}
                                        alt={`Try-on result ${index + 1}`}
                                        style={{ width: '100%', borderRadius: '8px' }}
                                    />
                                </Box>
                            ))}
                        </Box>
                    )}
                </Stack>
            </Box>
        );
    };

    const renderSubPageHeader = (title) => (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            mb: 3,
            pb: 2,
            borderBottom: '1px solid #e0e0e0'
        }}>
            <IconButton
                onClick={onCancel}
                sx={{ mr: 2 }}
            >
                <ArrowUpwardOutlinedIcon />
            </IconButton>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                {title}
            </Typography>
        </Box>
    );

    return (
        <Container>
            <Container maxWidth="md">

                {isLoading && <MockGeneralHeader />}
                {!isLoading && renderSubPageHeader("Products")}
                {isLoading && <MockProductImage />}

                {!isLoading && renderProductPhotos()}
                {!isLoading && renderProductInformation()}
                {!isLoading && product && renderVirtualTryOn()}
                {/* !isLoading && renderProductShopMoreInfo()  - fix rerender loop */}
            </Container>
        </Container>
    );
};

// Mapping Props and State
const shopProductDetail = connect(
    ({ userbootupInfo }) => ({
        reqStatus: userbootupInfo.reqStatus,
        isLoading: userbootupInfo.isLoading,
        serviceError: userbootupInfo.serviceError,
        tryonCredits: userbootupInfo.tryonCredits,
        tryonProfileImage: userbootupInfo.tryonProfileImage,
        virtualTryOnResult: userbootupInfo.virtualTryOnResult,
    }),
    (dispatch) =>
        bindActionCreators(
            { ...Actions }, dispatch)
)(ShopProductDetail);

export { shopProductDetail as default };
